import { render, staticRenderFns } from "./leaveStudentList.vue?vue&type=template&id=bdde5c22&scoped=true&"
import script from "./leaveStudentList.vue?vue&type=script&lang=js&"
export * from "./leaveStudentList.vue?vue&type=script&lang=js&"
import style0 from "./leaveStudentList.vue?vue&type=style&index=0&id=bdde5c22&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdde5c22",
  null
  
)

export default component.exports